import React, {Component} from 'react';
import {
    Button,
    Card,
    Col,
    ConfigProvider, DatePicker, Descriptions, Divider, Form,
    Input, message, Modal,
    notification,
    Popconfirm,
    Row, Select,
    Space,
    Table,
    Tag,
    Tooltip,
    Typography
} from 'antd';
import './TenantList.css';
import {fetchRequest} from "../../../util/APIUtils";
import ServerError from "../../../common/ServerError";
import Highlighter from 'react-highlight-words';
import {
    CalendarOutlined,
    CopyOutlined,
    DeleteOutlined,
    EditOutlined,
    EnvironmentOutlined,
    PlusOutlined,
    SearchOutlined
} from '@ant-design/icons';
import NotFound from "../../../common/NotFound";
import AccessError from "../../../common/AccessError";
import moment from "moment";
import {language} from "../../../util/language";
const {Paragraph, Text} =  Typography;

class TenantList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: [],
            total: 0,
            current: 1,
            pageSize: 5,
            pageSizeOptions:['5','10','20','50','100'],
            loading: false,
            searchQuery: '',
            keySearchQuery: '',
            accessor:'recordId',
            direction:'desc',
            openExportExcelModal:false,
            contractsByTenant: {},
            tenantModalVisible: false,
            contractModalVisible: false,
            selectedTenant: {
                recordId: null,
                firstName: '',
                familyName: '',
                phone: '',
                email: '',
            },
            selectedContract: {},
            notFound: false,
            serverError: false,
            accessError: false,
            searchedColumn: '',
            searchText: '',
            tenantModalMode: null,
            contractMode: null,
            contractInfo: {},
            selectedLease: {apartment:{}, tenant:{}, contractEndDate:'',contractStartDate:'',},
            availableApartments: []

        };
        this.fetchData         = this.fetchData.bind(this);
        this.fetchLeases         = this.fetchLeases.bind(this);
        this.handleMenuClick   = this.handleMenuClick.bind(this);
        this.onChange          = this.onChange.bind(this);
        this.handleSearch      = this.handleSearch.bind(this);
        this.handleReset       = this.handleReset.bind(this);
        this.statusConvertToDisplayText = this.statusConvertToDisplayText.bind(this);
        this.setSearchQuery = this.setSearchQuery.bind(this);
        this.formatAddress = this.formatAddress.bind(this);
        this.copyToClipboard = this.copyToClipboard.bind(this);
        this.setTenantModalVisible = this.setTenantModalVisible.bind(this);
        this.setContractModalVisible = this.setContractModalVisible.bind(this);
        this.deleteTenantRecord = this.deleteTenantRecord.bind(this);
        this.deleteContractRecord = this.deleteContractRecord.bind(this);
        this.handleAddNewTenant = this.handleAddNewTenant.bind(this);
        this.handleAddNewContract = this.handleAddNewContract.bind(this);
        this.handleChangeTenant = this.handleChangeTenant.bind(this);
        this.getAvailableApartments = this.getAvailableApartments.bind(this);
        this.handleChangeLease = this.handleChangeLease.bind(this);
    }

    componentDidMount() {
        this.fetchData();
        this.getAvailableApartments();
    }

    fetchData() {
        let self = this;
        this.setState({loading: true});
        const {accessor,direction,current,pageSize,searchQuery,keySearchQuery} = self.state;
        fetchRequest({},`/tenant/fetch?page=${current-1}&size=${pageSize}${keySearchQuery + searchQuery}&sort=${accessor},${direction}`)
        .then(response => {
            let {number, size, totalElements,content} = response.data;
            this.setState({
                loading: false,
                current:number+1,
                pageSize:size,
                total:totalElements,
                content
            });
        }).catch(error => {
            if(error.status === 404) {
                this.setState({notFound: true});
            } else if(error.response.status === 401) {
                notification.error({
                    message: 'Hata',
                    description: 'Kullanıcı adı veya şifre hatalı, tekrar deneyiniz!'
                });
            } else if(error.response.status === 400) {
                notification.error({
                    message: 'Hata',
                    description: error.response.data
                });
                this.setState({notFound: true});
            } else if(error.response.status === 403) {
                notification.error({
                    message: 'Hata',
                    description: "Bu sayfayı görmeye yetkiniz bulunmamaktadır."
                });
                this.setState({accessError: true});
            } else {
                this.setState({serverError: true});
            }
            this.setState({loading: false});
        });
    }

    getAvailableApartments(){
        const url = '/apartment/fetchAvailableAparts';
        this.setState({loading: true})
        fetchRequest({}, url).then(response => {
            let map = response.data;
            const options = map.map((item, index) => {
                return {
                    value: item[0],
                    label: item[1]
                }
            })
            console.log(response.data);
            this.setState({availableApartments: options, loading: false, });
            console.log(response.data);
        }).catch(error => {})
    }

    fetchLeases(tenantId){
        const url = `/lease/fetchByTenantId/${tenantId}`;
        this.setState({loading: true})
        fetchRequest({}, url).then(response => {
            var map = Object.assign({}, this.state.contractsByTenant);
            map[tenantId] = response.data;
            this.setState({contractsByTenant: map, loading: false});
            console.log(response.data);
        }).catch(error => {})
    }

    onChange(pagination, filters, sorter, extra) {
        let searchQuery = '';
        if(filters.firstName && filters.firstName.length>0){
            searchQuery = searchQuery + `&firstName=${filters.firstName[0]}`;
        }
        if(filters.familyName && filters.familyName.length>0){
            searchQuery = searchQuery + `&familyName=${filters.familyName[0]}`;
        }
        this.setState({
            searchQuery,
            accessor:sorter.field  ? sorter.field : this.state.accessor,
            direction:sorter.order ? (sorter.order==='ascend'?'asc':'desc') : this.state.direction,
            current:pagination.current,
            pageSize:pagination.pageSize
        },() => this.fetchData());
    }

    handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    }
    getCurrencies(){
        return ([{value: 'IQD', text: 'IQD'},{value: 'USD', text: 'USD'},{value: 'EUR', text: 'EUR'},{value: 'TRY', text: 'TRY'}])
    }

    handleReset(clearFilters) {
        clearFilters();
        this.setState({ searchText: '' });
    }

    handleMenuClick(e) {
        let item = e.item;
    }

    getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={language(this.props.lang, 'search')}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    {language(this.props.lang, 'search')}
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    {language(this.props.lang, 'clear')}
                </Button>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    statusConvertToDisplayText(value){
        if(value) return language(this.props.lang, 'active');
        return language(this.props.lang, 'terminated');
    }


    setSearchQuery(text){
        let self = this;
        self.setState({keySearchQuery:text,total: 0,current: 1,pageSize: 5},()=>self.fetchData());
    }

    formatAddress(apartment){
        console.log(apartment)
        if(!apartment) return "-";
        var city = apartment.city ? apartment.city : "";
        /*var neighborhood = apartment.neighborhood || apartment.district || "";*/
        var street = apartment.streetName || '';
        var buildingName = apartment.buildingName || '';
        var buildingNo = apartment.buildingNo || '';
        var apartmentNo = apartment.apartmentNo || '';
        var postalCode = apartment.postalCode || '';

        let lang = this.props.lang;
        if(lang === 'tr'){
            var tr = [];
            if(city) tr.push(city);
           /* if(neighborhood) tr.push(neighborhood + ' Mahallesi');*/
            if(street) tr.push(street + ' Caddesi');
            if(street)
                var  bTr = [];
            if(buildingName) bTr.push(buildingName + ' Blok');
            if(buildingNo) bTr.push('No: ' + buildingNo);
            if(bTr.length > 0) tr.push(bTr.join(' '));
            if(apartmentNo) tr.push('Daire: ' + apartmentNo);
            if(postalCode) tr.push('PK:' + postalCode);
            return tr.join(', ');
        }
        if(lang === 'ar'){
            var ar = [];
            if(city) ar.push(city);
           /* if(neighborhood) ar.push('حي ' + neighborhood );*/
            if(street) ar.push('شارع' + street );
            if(street)
                var  bAr = [];
            if(buildingName) bAr.push('بناية' + buildingName );
            if(buildingNo) bAr.push('(' + buildingNo + ')');
            if(bAr.length > 0) ar.push(bAr.join(' '));
            if(apartmentNo) ar.push('شقة: ' + apartmentNo);
            if(postalCode) ar.push( postalCode);
            return ar.join(', ');
        }

        if(lang === 'en'){
            var en = [];
            if(city) en.push(city);
           /* if(neighborhood) en.push(neighborhood );*/
            if(street) en.push(street + ' St');
            if(street)
                var  bEn = [];
            if(buildingName) bEn.push('Building ' + buildingName );
            if(buildingNo) bEn.push('#' + buildingNo);
            if(bEn.length > 0) en.push(bEn.join(' '));
            if(apartmentNo) en.push('Apt ' + apartmentNo);
            if(postalCode) en.push( postalCode);
            return en.join(', ');
        }
    }

    isActive(lease){
        var endOk = !lease.terminated_date || new Date(lease.contractEndDate) > new Date();
        return lease.terminated === false && endOk;
    }

    copyToClipboard(address){
        if(address){
            navigator.clipboard.writeText(address).then(() => {
                message.success(language(this.props.lang, 'address_copied'));
            }).catch(err => {
                message.error(language(this.props.lang, 'address_copy_error'));
            })
        }
    }

    setTenantModalVisible(isVisibile){
        this.setState({tenantModalVisible: isVisibile});

    }

    setContractModalVisible(isVisibile, record){
        let selectedLease = JSON.parse(JSON.stringify(this.state.selectedLease));
        console.log(selectedLease)
        selectedLease.tenant = record;
        this.setState({contractModalVisible: isVisibile, selectedLease});
    }

    deleteTenantRecord(){

    }

    deleteContractRecord(){

    }

    handleAddNewTenant(tenant){
        this.setState({loading: true});
        fetchRequest(tenant, '/tenant/save').then(response => {
            if (response.status === 200) {
                notification.success({
                    message: language(this.props.lang, 'success'),
                });
                this.fetchData();
                this.setState({selectedTenant: {}, tenantModalVisible: false});
            }else{
                notification.error({
                    message: language(this.props.lang, 'error'),
                    description: response.data
                });
                this.setState({accessError: true});
            }
        }).catch(error => {
            if (error.status === 404) {
                this.setState({notFound: true});
            } else if (error.response.status === 401) {
                notification.error({
                    message: language(this.props.lang, 'error'),
                    description: language(this.props.lang, 'user_name_or_password_is_wrong')
                });
            } else if (error.response.status === 400) {
                notification.error({
                    message: language(this.props.lang, 'error'),
                    description: error.response.data
                });
                this.setState({notFound: true});
            } else if (error.response.status === 403) {
                notification.error({
                    message: language(this.props.lang, 'error'),
                    description: "Bu sayfayı görmeye yetkiniz bulunmamaktadır."
                });
                this.setState({accessError: true});
            } else {
                this.setState({serverError: true});
            }
        })
        this.setState({loading: false});

    }

    handleAddNewContract(){
        let contract = JSON.parse(JSON.stringify(this.state.selectedLease));
        console.log(contract)
        this.setState({loading: true});
        fetchRequest(contract, '/lease/save').then(response => {
            if (response.status === 200) {
                notification.success({
                    message: language(this.props.lang, 'success'),
                });
                this.fetchData();
                this.setState({selectedLease: {}, contractModalVisible: false});
            }else{
                notification.error({
                    message: language(this.props.lang, 'error'),
                    description: response.data
                });
                this.setState({accessError: true});
            }
        }).catch(error => {
            if (error.status === 404) {
                this.setState({notFound: true});
            } else if (error.response.status === 401) {
                notification.error({
                    message: language(this.props.lang, 'error'),
                    description: language(this.props.lang, 'user_name_or_password_is_wrong')
                });
            } else if (error.response.status === 400) {
                notification.error({
                    message: language(this.props.lang, 'error'),
                    description: error.response.data
                });
                this.setState({notFound: true});
            } else if (error.response.status === 403) {
                notification.error({
                    message: language(this.props.lang, 'error'),
                    description: "Bu sayfayı görmeye yetkiniz bulunmamaktadır."
                });
                this.setState({accessError: true});
            } else {
                this.setState({serverError: true});
            }
        })
        this.setState({loading: false});
    }

    handleChangeTenant(e) {
        const {name, value} = e.target;
        this.setState((prev) => ({selectedTenant: {...prev.selectedTenant, [name]: value}}));
    }

    handleChangeLease(e) {
        console.log(e.target)
        const {name, value} = e.target;
        if(name === 'apartmentId'){
            let selectedLease = JSON.parse(JSON.stringify(this.state.selectedLease));
            selectedLease.apartment.recordId = value;
            this.setState({selectedLease});
        }else{

            this.setState((prev) => ({selectedLease: {...prev.selectedLease, [name]: value}}));
        }
    }

    render() {

        let {selectedTenant, selectedLease, availableApartments} = this.state;
        if(this.state.serverError) {
            return <ServerError />;
        }

        if(this.state.notFound) {
            return <NotFound />;
        }

        if(this.state.accessError) {
            return <AccessError />;
        }

        const tenantCols = [
            {
                title: '#',
                dataIndex: 'index',
                key: 'index',
                width: '1%',
                render: (text, record, index) => (
                    <label>{index+1}</label>
                )
            },
            {
                title: language(this.props.lang, 'first_name'),
                dataIndex: 'firstName',
                key: 'firstName',
                width: '15%',
                sorter:true,
                ...this.getColumnSearchProps('firstName'),
            },
            {
                title:  language(this.props.lang, 'family_name'),
                dataIndex: 'familyName',
                key: 'familyName',
                width: '15%',
                sorter:true,
                ...this.getColumnSearchProps('familyName'),
            },
            {
                title:  language(this.props.lang, 'phone'),
                dataIndex: 'phone',
                key: 'phone',
                width: '15%',
                sorter:true,
                ...this.getColumnSearchProps('phone'),
            },
            {
                title:  language(this.props.lang, 'email'),
                dataIndex: 'email',
                key: 'email',
                width: '15%',
                sorter:true,
                ...this.getColumnSearchProps('email'),
            },
            {
                title: language(this.props.lang, 'actions'),
                key: 'actions',
                width: '10%',
                render: (text, record) => (
                    <Space>
                        <Button icon={<PlusOutlined/>} shape="circle" type="primary" onClick={() => this.setContractModalVisible(true, record)}/>
                        <Popconfirm title={language(this.props.lang, "sure_to_delete")} onConfirm={() =>this.deleteTenantRecord(record.recordId)}>
                            <Button icon={<DeleteOutlined/>} shape="circle" type="danger" />
                        </Popconfirm>
                        <Button icon={<EditOutlined/>} shape="circle" type="ghost" onClick={() => this.setState({tenantModalVisible: true, tenantModalMode: 'edit', selectedTenant: record})}/>
                    </Space>
                )}
            /*,
            {
                title: 'Tarih',
                dataIndex: 'updatedAt',
                key: 'updatedAt',
                width: '5%',
                sorter:true,
                render: (text, record) => (
                    <label>{moment(record.updatedAt).format("DD-MM-YYYY HH:mm")}</label>
                )
            }*/
        ];

        const leaseCols = [
            {
                title: '#',
                dataIndex: 'index',
                key: 'index',
                width: '3%',
                render: (text, record, index) => (
                    <label>{index+1}</label>
                )
            },
            {
                title: language(this.props.lang, 'address'),
                dataIndex: 'apartment',
                key: 'address',
                width: '15%',
                sorter:true,
                render: ((apartment, record) =>  this.formatAddress(apartment, ))
            },
            {
                title: language(this.props.lang, 'contract_start_date'),
                dataIndex: 'contractStartDate',
                key: 'contractStartDate',
                width: '15%',
                sorter:true,
                ...this.getColumnSearchProps('contractStartDate'),
            },
            {
                title: language(this.props.lang, 'contract_end_date'),
                dataIndex: 'contractEndDate',
                key: 'contractEndDate',
                width: '15%',
                sorter:true,
                ...this.getColumnSearchProps('contractEndDate'),
            },{
                title: language(this.props.lang, 'contract_status'),
                dataIndex: 'terminated',
                key: 'terminated',
                width: '15%',
                render: termintaed => {
                    const color = termintaed == false ? 'green' : 'volcano';
                    const text = termintaed == false ? language(this.props.lang, 'active') : language(this.props.lang, 'terminated');
                    return (<Tag color={color}>{text}</Tag>)
                }}
                ,{
                title: language(this.props.lang, 'terminated_date'),
                dataIndex: 'terminatedDate',
                key: 'terminatedDate',
                width: '15%',
            },{
                title: language(this.props.lang, 'amount'),
                dataIndex: 'amount',
                key: 'amount',
                width: '15%',
            },{
                title: language(this.props.lang, 'currency_type'),
                dataIndex: 'currencyType',
                key: 'currencyType',
                width: '15%',
            },{
                title: language(this.props.lang, 'updated_at'),
                dataIndex: 'updatedAt',
                key: 'updatedAt',
                width: '15%',
                render: (text, record) => (
                    <label>{moment(record.updatedAt).format("DD-MM-YYYY HH:mm")}</label>
                )
            },
            ];


        const {total,current,pageSize,pageSizeOptions,content} =  this.state;

        return (
            <div className="tenant-container">
                <ConfigProvider direction={this.props.lang === 'ar' ? 'rtl' : 'ltr'}>
                    <Card>
                        <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '10px', alignItems: 'center', zIndex: 2, position: 'relative'}}>
                            <h3 style={{margin: 0}}>{language(this.props.lang, 'tenant_lease_list')}</h3>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            float: this.props.lang === 'ar' ? 'left' : 'right',
                            marginBottom: '10px'
                        }}>
                            <Button type="primary" size={"large"}
                                    shape="circle" icon={<PlusOutlined/>} onClick={() => this.setTenantModalVisible(true)}/>
                        </div>
                        </div>
                        <Modal
                            title={this.state.tenantModalMode === "edit" ? language(this.props.lang, 'edit_tenant') : language(this.props.lang, 'add_new_tenant')}
                            visible={this.state.tenantModalVisible}
                            footer={null}
                            onCancel={() => this.setTenantModalVisible(false)}
                        >
                            <Form id="tenantForm" layout="vertical" name="tenantForm"
                                  initialValues={{
                                      firstName: selectedTenant.firstName || '',
                                      familyName: selectedTenant.familyName || '',
                                      phone: selectedTenant.phone || '',
                                      email: selectedTenant.email || '',
                                  }}
                                  onFinish={(values) => this.handleAddNewTenant({...(this.state.selectedTenant || {}), ...values})}>
                                <Form.Item
                                    label={language(this.props.lang, 'first_name')}
                                    name="firstName"
                                    rules={[{ required: true, message: language(this.props.lang, 'first_name_required') }]}
                                >
                                    <Input name={"firstName"} value={selectedTenant.firstName} placeholder={language(this.props.lang, 'first_name')} onChange={this.handleChangeTenant}/>
                                </Form.Item>
                                <Form.Item
                                    label={language(this.props.lang, 'family_name')}
                                    name="familyName"
                                    rules={[{ required: true, message: language(this.props.lang, 'family_name_required') }]}
                                ><Input name={"familyName"} value={selectedTenant.familyName} placeholder={language(this.props.lang, 'family_name')} onChange={this.handleChangeTenant}/>
                                </Form.Item>
                                <Form.Item label={language(this.props.lang, 'phone')} name="phone"
                                           rules={[{ required: true, message: language(this.props.lang, 'phone_required') }]}>
                                    <Input name="phone" value={selectedTenant.phone} placeholder={language(this.props.lang, 'phone')} onChange={this.handleChangeTenant}/>
                                </Form.Item>
                                <Form.Item label={language(this.props.lang, 'email')} name="email"
                                           rules={[{ required: true, message: language(this.props.lang, 'email_required') }]}>
                                    <Input name="email" value={selectedTenant.email} placeholder={language(this.props.lang, 'email')} onChange={this.handleChangeTenant}/>
                                </Form.Item>
                            </Form>
                            <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '10px'}}>
                                <Button type="primary" htmlType="submit" form="tenantForm">{language(this.props.lang, 'save')}</Button>
                                <Button type="default" onClick={() => this.setTenantModalVisible(false)}>{language(this.props.lang, 'cancel')}</Button>
                            </div>
                        </Modal>
                        <Modal
                            title={this.state.contractMode === "edit" ? language(this.props.lang, 'edit_contract') : language(this.props.lang, 'add_new_contract')}
                            visible={this.state.contractModalVisible}
                            footer={null}
                            onCancel={() => this.setState({contractModalVisible: false})}
                            width={this.props.lang === 'ar' ? '6%0' : '50%'}
                        >
                            <Descriptions size="small" column={1} bordered>
                                <Descriptions.Item label={language(this.props.lang, 'tenant_person')}>
                                    {selectedLease.tenant && (
                                        <Text strong>
                                        {selectedLease.tenant.firstName + ' ' + selectedLease.tenant.familyName}
                                        </Text>
                                    )}
                                </Descriptions.Item>
                            </Descriptions>

                            <Divider style={{margin: '10px 0'}} />
                            <Form id="contractForm" layout="vertical" name="contractForm"
                                  initialValues={{
                                      tenantId: selectedLease.tenant ? selectedLease.tenant.recordId : null,
                                      apartmentId: selectedLease.apartment ? selectedLease.apartment.recordId : null ,
                                  }}
                                  onFinish={(values) => this.handleAddNewContract({...(this.state.contractInfo || {}), ...values})}>
                                <Form.Item label={language(this.props.lang, 'apartment')} name="apartmentId"
                                           rules={[{ required: true, message: language(this.props.lang, 'apartment_required') }]}>
                                <Select showSearch
                                        placeholder={language(this.props.lang, 'select_apartment')}
                                        optionFilterProp="label"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        options={(availableApartments || [])}
                                        onChange={(value) => this.handleChangeLease({
                                            target: {
                                                name: 'apartmentId',
                                                value: value
                                            }
                                        })}
                                        value={(selectedLease.apartment && selectedLease.apartment.recordId || null) && (
                                            availableApartments.find(apartment => apartment.value === selectedLease.apartment.recordId)
                                        )}
                                        style={{width: '100%'}} />
                                </Form.Item>
                                <Form.Item label={language(this.props.lang, 'contract_start_date')} name="contractStartDate"
                                           rules={[{ required: true, message: language(this.props.lang, 'contract_start_date_required') }]}>
                                    <DatePicker style={{width: '100%'}} name="contractStartDate"
                                                placeholder={language(this.props.lang, 'contract_start_date')}
                                                onChange={(date, dateString) => this.handleChangeLease({target: {name: 'contractStartDate', value: dateString}})}/>
                                </Form.Item>
                                <Form.Item label={language(this.props.lang, 'contract_end_date')} name="contractEndDate"
                                           rules={[{ required: true, message: language(this.props.lang, 'contract_end_date_required') }]}>
                                    <DatePicker style={{width: '100%'}} name="contractEndDate"
                                                placeholder={language(this.props.lang, 'contract_end_date')}
                                                onChange={(date, dateString) => this.handleChangeLease({target: {name: 'contractEndDate', value: dateString}})}/>
                                </Form.Item>
                                {/*<Form.Item shouldUpdate dependencies={['contractStartDate']}>
                                    {(getFieldValue) => (
                                        <Form.Item label={language(this.props.lang, 'contract_end_date')}
                                                   name="contractEndDate"
                                                   rules={[{
                                                       required: true,
                                                       message: language(this.props.lang, 'contract_end_date_required')
                                                   }]}>
                                            <DatePicker style={{width: '100%'}} name="contractEndDate"
                                                        placeholder={language(this.props.lang, 'contract_end_date')}
                                                        disabledDate={(current) => {
                                                            const s = getFieldValue('contractStartDate');
                                                            return !!(s && current && current.isBefore(s, 'day'))
                                                        }}
                                                        onChange={(date, dateString) => this.handleChangeLease({
                                                            target: {
                                                                name: 'contractEndDate',
                                                                value: dateString
                                                            }
                                                        })}/>
                                        </Form.Item>

                                    )}
                                </Form.Item>*/}
                                <Form.Item label={language(this.props.lang, 'amount')} name="amount"
                                           rules={[{ required: true, message: language(this.props.lang, 'amount_required') }]}>
                                    <Input name="amount" placeholder={language(this.props.lang, 'amount')} onChange={this.handleChangeLease}/>
                                </Form.Item>
                                <Form.Item label={language(this.props.lang, 'currency_type')} name="currencyType"
                                           rules={[{ required: true, message: language(this.props.lang, 'currency_type_required') }]}>
                                    <Select showSearch
                                            placeholder={language(this.props.lang, 'select_currency_type')}
                                            optionFilterProp="label"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            options={this.getCurrencies()}
                                            onChange={(value) => this.handleChangeLease({target: {name: 'currencyType', value: value}})}
                                    />
                                </Form.Item>
                            </Form>
                            <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '10px'}}>
                                <Button type="primary" htmlType="submit" form="contractForm">{language(this.props.lang, 'save')}</Button>
                                <Button type="default" onClick={() => this.setState({contractModalVisible: false})}>{language(this.props.lang, 'cancel')}</Button>
                            </div>
                        </Modal>
                        <Table dataSource={content}
                               rowKey={record => record.recordId}
                               expandable={{
                                   onExpand: (expanded, record) => {
                                       if(expanded){
                                           this.fetchLeases(record.recordId)
                                       }
                                   },
                                   expandedRowRender: (record) => {
                                       var rows = this.state.contractsByTenant[record.recordId] || [];
                                       return(
                                           <Row gutter={16}>
                                               {rows.map((lease,index) => {
                                                   var active = this.isActive(lease);
                                                   var statusText = this.statusConvertToDisplayText(active);
                                                   var statusColor = active ? 'green' : 'volcano';
                                                   const address = this.formatAddress(lease.apartment);

                                                   return (
                                                       <Col key={lease.recordId} xs={24} sm={12} md={8} >
                                                           <Card  title={<Space size={10} style={{width: '100%', justifyContent: 'space-between'}}>
                                                               <Text strong>{language(this.props.lang, "lease_contract")} #{index+1}</Text>
                                                               <Tag color={statusColor}>{statusText}</Tag>
                                                           </Space>} size={"small"} style={{height:'100%', borderRadius: 10}}
                                                                  headStyle={{paddingInline: 16, paddingBlock :10}}
                                                                  bodyStyle={{padding: 16}} bordered>
                                                               <Space align={"start"}>
                                                                   <Tooltip title={language(this.props.lang, "address")}>
                                                                   <div style={{fontWeight: 600, backgroundColor: '#f5f5f5'}}>
                                                                       {address}
                                                                   </div>
                                                                   </Tooltip>
                                                                   <EnvironmentOutlined style={{opacity: .6}}>
                                                                       <div style={{fontWeight: 600, backgroundColor: '#f5f5f5'}}></div>
                                                                   </EnvironmentOutlined>
                                                                   <Button icon={<CopyOutlined/>} shape="circle" type="primary" onClick={() => this.copyToClipboard(address)}/>
                                                                   {/*{lease.terminated_date &&}*/}
                                                                   <Button icon={<EditOutlined/>} shape="circle" type="ghost"/>
                                                               </Space>

                                                               <Divider style={{margin: '10px 0'}} />
                                                               <div style={{
                                                                   display: 'grid',
                                                                   gridTemplateColumns: '1fr 1fr',
                                                                   gridGap: '10px',
                                                                   padding: '10px'
                                                               }}>
                                                                   <div>
                                                                       <div style={{opacity: 0.65}}> <Text type={"secondary"} style={{color: 'black', marginRight: 8, whiteSpace: 'nowrap'}}><CalendarOutlined/> {language(this.props.lang, "contract_start_date")}</Text>
                                                                           <div style = {{color: "black", fontWeight: 'bold'}}>{lease.contractStartDate ? new Date(lease.contractStartDate).toLocaleDateString('tr-TR') : '-'}</div>
                                                                       </div>
                                                                       <div style={{opacity: 0.65}}> <Text type={"secondary"} style={{color: 'black', marginRight: 8, whiteSpace: 'nowrap'}}><CalendarOutlined/> {language(this.props.lang, "contract_end_date")}</Text>
                                                                           <div style = {{color: "black", fontWeight: 'bold'}}>{lease.contractEndDate ? new Date(lease.contractEndDate).toLocaleDateString('tr-TR') : '-'}</div>
                                                                       </div>
                                                                       <div style={{opacity: 0.65}}> <Text type={"secondary"} style={{color: 'black', marginRight: 8, whiteSpace: 'nowrap'}}>{language(this.props.lang, "amount")}</Text>
                                                                           <div style = {{color: "black", fontWeight: 'bold'}}>{lease.amount ? lease.amount + " "+ lease.currencyType: '-'}</div>
                                                                       </div>

                                                                   </div>
                                                               </div>
                                                           </Card>
                                                       </Col>
                                                   )
                                               })}
                                           </Row>
                                           /*<Table rowKey="id" dataSource={rows}
                                                  columns={leaseCols} pagination={false} size={"small"} />*/
                                       )
                                   }

                               }}
                               size="small"
                               columns={tenantCols}
                               onChange={this.onChange}
                               loading={this.state.loading}
                               locale={{
                                   filterConfirm: 'Tamam',
                                   filterReset: 'Temizle'
                               }}
                               pagination={{
                                   total,
                                   current,
                                   pageSize,
                                   pageSizeOptions,
                                   showSizeChanger:true,
                                   showQuickJumper:true,
                                   showTotal:(total) => language(this.props.lang, 'total_records') + ": " + total
                               }}
                        />
                    </Card>
                </ConfigProvider>
            </div>
        );
    }
}

export default TenantList;


// WEBPACK FOOTER //
// ./src/page/tenant/tenant/TenantList.js